type CategoriesFailureMap<R> = {
  serverFailure: () => R;
  networkFailure: () => R;
};

type CategoriesFailureMaybeMap<R> = {
  serverFailure?: () => R;
  networkFailure?: () => R;
  orElse: () => R;
};

abstract class _CategoriesFailure extends Error {
  public abstract map<R>(callbacks: CategoriesFailureMap<R>): R;
  public abstract maybeMap<R>(callbacks: CategoriesFailureMaybeMap<R>): R;
}

class ServerFailure extends _CategoriesFailure {
  constructor() {
    super("ServerFailure");
  }

  public map<R>(callbacks: CategoriesFailureMap<R>): R {
    return callbacks.serverFailure();
  }

  public maybeMap<R>(callbacks: CategoriesFailureMaybeMap<R>): R {
    if (callbacks.serverFailure) return callbacks.serverFailure();
    return callbacks.orElse();
  }
}

class NetworkFailure extends _CategoriesFailure {
  constructor() {
    super("NetworkFailure");
  }

  public map<R>(callbacks: CategoriesFailureMap<R>): R {
    return callbacks.networkFailure();
  }

  public maybeMap<R>(callbacks: CategoriesFailureMaybeMap<R>): R {
    if (callbacks.networkFailure) return callbacks.networkFailure();
    return callbacks.orElse();
  }
}

export type CategoriesFailure = ServerFailure | NetworkFailure;

export const CategoriesFailure = {
  serverFailure: () => new ServerFailure(),
  networkFailure: () => new NetworkFailure(),
};
